import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SegundaViaCertificado } from '../../interfaces/dashboard/segunda-via-certificado.interface';

@Injectable({
  providedIn: 'root'
})
export class SegundaViaCertificadoService {

  private _http = inject(HttpClient);

  getSegundasVias(): Observable<SegundaViaCertificado[]> {
    return this._http.get<SegundaViaCertificado[]>(environment.url + '/api/segunda-via-certificado').pipe(
      catchError(error => {
        console.error('Erro ao carregar segundas vias de certificado:', error);
        return throwError(() => error);
      })
    );
  }
}
